import '../../../../../src/Styles/Order.css'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';

export function DscOrderZP(props) {
  const { orderData } = props;
  return (
    <div>
      <div className="call-letter-container">
        <div className="call-letter" id='print-table'>
          <DscOrderZpHeader orderData={orderData} />
          <DscOrderZpSubject orderData={orderData} />
          <DscOrderZpOrder orderData={orderData} from="ZP" />
          <DscOrderMpInstList inst={instructions} />
          <DscOrderMpFooter orderData={orderData} />
        </div>
      </div>
    </div>
  );
}
export const DscOrderZpHeader = (props) => {
  const { orderData } = props;
  return (<div className='table-responsive'>
    <table className="header-table" role="presentation">
      <tbody>
        <tr><td className='text-center' colSpan={2}> <div className="center-text">PROCEEDINGS OF THE DISTRICT EDUCATIONAL OFFICER & MEMBER </div></td></tr>
        <tr><td header-col1>
          <p className="center-text">CONVENOR, DSC-2025 : {orderData?.dist_name ? (<strong>{orderData?.dist_name}</strong>) : ("__________________")}{" "}District</p>
          <p className="center-text" >Present:__________________</p>
          <div className="flex-between">
            <p className='underline-text'>Rc No. __________________</p>
            <p className='underline-text'>Dated: __________________</p>
          </div>
        </td>
          <td className='header-col2' >
            <div className='float-end'><img src={orderData?.img_path ? config.url.FILE_DOWNLOAD_URL + orderData?.img_path : '#'}
              className='img-photo'
              alt="studentphoto"
              style={{
                width: "130px",
                height: "130px",
              }} /></div></td></tr>
      </tbody>
    </table >
  </div >)
}
export const DscOrderZpSubject = (props) => {
  const { orderData } = props;
  return (<div className='px-4 mt-1'><table className="header-table table-dotted table-responsive" role="presentation">
    <tbody><tr><td>Sub:</td><td> APES –Mega DSC-2025 – Appointment to the post of {" "} {orderData?.post_name ? (<strong>{orderData?.post_name}</strong>) : ("__________________")}{" "}
      - Orders issued - Regarding.</td></tr>
      <tr><td>Read:</td><td>
        <ol>
          <li>Notification No.02/MEGA DSC-TRC-1/2025, Dated: 20-04-2025</li>
          <li>G.O.Ms.No.15 SE Dept Dt.19.04.2025</li>
          <li>G.O.Ms.No.17 SE Dept Dt.28.04.2025</li>
        </ol></td></tr></tbody>
  </table></div>)
}
export const DscOrderZpOrder = (props) => {
  const { orderData, from } = props;
  return (<div className='mt-2'> <h6 className="underline-text">ORDER:</h6>
    <p className="justify-text">
      In accordance with the directives outlines in the aforementioned references and pursuant to Rule 10 of the AP State and Subordinate Service Rules,
      1996 read with {from === 'ZP' && 'G.O.Ms.No.11 & 12, SE (Ser.II) Dept., dated:23.01.2009 and as amended thereon and'} G.O.Ms.No.320, 322, 323 & 324, MAUD Dept.,
      dated:07.12.2016 and their subsequent amendments, Sri/Smt./Kum. {orderData?.applicant_name ? (<strong>{orderData?.applicant_name}</strong>) : ("__________________")}{" "}
      S/D/o {" "}{orderData?.father_name ? (<strong>{orderData?.father_name}</strong>) : ("__________________")}{" "}
      with Hall Ticket No. {orderData?.candidate_id ? (<strong>{orderData?.candidate_id}</strong>) : ("__________________")} {" "}
      has been selected through Mega DSC-2025 and is hereby appointed as {orderData?.post_name ? (<strong>{orderData?.post_name}</strong>) : ("__________________")} {" "}
      under {orderData?.management ? (<strong>{orderData?.management}</strong>) : ("__________________")} {" "} Management subject to the following conditions:</p>
  </div>)
}
export const DscOrderMpInstList = (props) => {
  const { inst } = props;
  return (
    <ol className="justify-text">
      {inst?.map((item) => (
        <li key={item.key}>
          {item.value}
        </li>
      ))}
    </ol>
  )
}
export const DscOrderMpFooter = (props) => {
  const { orderData } = props;
  return (
    <div className="">

      <div className="signature-container">
        <div className="signature">
          <div className="call-letter-sign">
            <img
              src="../img/original_sign.jpeg"
              className="img-fluid"
              alt="Signature"
            />
            District Educational Officer and <br />
            Member Convenor DSC-2025 <br />
            {orderData?.dist_name ? (
              <strong>{orderData?.dist_name}</strong>
            ) : (
              "__________________"
            )}{" "}
            district
          </div>
        </div>
      </div>
      {/* <div className="right-text">
        <img
          src="../img/original_sign.jpeg"
          className="img-fluid"
          alt="Signature"
        />
        District Educational Officer and <br />
        Member Convenor DSC-2025 <br />
        {orderData?.dist_name ? (
          <strong>{orderData?.dist_name}</strong>
        ) : (
          "__________________"
        )}{" "}
        district
      </div> */}
      <div className="float-left">
        To<br />
        Sri/Smt/Kum {orderData?.applicant_name ? (<strong>{orderData?.applicant_name}</strong>) : ("__________________")}{" "}.<br />
        Copy to the Mandal Educational Officer/Headmaster concerned.<br />
        Copy to the Deputy Educational Officer concerned.<br />
        Copy forwarded to the Chief Executive Officer, ZillaParishad,{orderData?.dsc_officer_name ? (<strong>{orderData?.dsc_officer_name}</strong>) : ("__________________")}{" "}.<br />
        Copy forwarded to the Municipal Commissioner,______________.<br />
        Copy forwarded to the DTO/STO concerned.<br />
      </div>

    </div>

  )
}
export const instructions = [
  { key: 1, value: "The seniority for the current position will be calculated from the date of joining, in accordance with Rules 33 (a) of A.P. State and Subordinate Service Rules." },
  { key: 2, value: "The individual qualifies for monetary benefits starting from the date of joining only." },
  { key: 3, value: "The appointment is strictly temporary and is subject to the directions/judgements issued by Hon’ble Courts from time to time and this appointment is entirely adhoc." },
  { key: 4, value: "If the certificates furnished by the candidate in respect of qualifications, EWS, local area, caste, PHC and Sports etc., are found to be non-genuine/Fake, bogus, the selection will be revoked, and a criminal case will be initiated against the individual without any further notice." },
  { key: 5, value: "The individual should join duty within 30 days from the date of receipt of appointment orders, failing which appointment will be cancelled without any further notice." },
  { key: 6, value: "The individual should produce original certificates issued by the competent authority, along with a physical fitness certificate in the prescribed proforma, issued not below the rank of civil surgeon to the Head master/ Mandal Educational Officer prior to his/her joining duty for verification." },
  { key: 7, value: "The individual services are governed by the New Contributory Pension Scheme rules prescribed in G.O.Ms.No.654, Finance, dated: 22/09/2004 and G.O.Ms. No.655, Finance, dated: 22/09/2004." },
  { key: 8, value: "The individual must adhere to the “undertaking” given by him/her. That the Head of the Institution or Mandal Educational Officer shall obtain a declaration/undertaking from the individual to the effect that he shall abide by the conditions of the appointment order and shall not deviate anything in future whatever may be the position and submit the same to the District Educational Officer." },
  { key: 9, value: "The Headmaster/Mandal Educational Officer concerned is requested verify all certificates relating to academic and professional qualifications, EWS, local area, caste, PHC, physical fitness certificate, relevant to the post to which individual is appointed before admitting the candidate, and if any discrepancy noticed, it may be intimated to the District Educational Officer immediately." },
  { key: 10, value: "The individual appointment is subject to the verification of character and antecedents by the competent authorities. If any adverse report is received, the appointment is liable to be cancelled without any notice." },
  { key: 11, value: "The individual appointed will undergo a probationary period lasting two years of active duty within a continuous timeframe of three years from the date of joining, in accordance with the A.P. State and Subordinate Service Rules. Confirmation in the position will depend on the successful completion of the probationary period and the verification of background information." },
  { key: 12, value: "The individual appointed shall undergo such induction or in-service training as mandated by the School Education Department or the Government from time to time." },
  { key: 13, value: "The appointee shall be governed by the Andhra Pradesh Civil Services (Conduct) Rules, 1964 and the A.P. Civil Services (CCA) Rules, 1991, and shall be liable for disciplinary action for any misconduct or violation of rules." },
  { key: 14, value: "The individual appointed shall ensure that their details are correctly entered in the Teacher Information System (TIS) portal and shall update service records promptly as instructed. The Head of the Institution/Mandal Educational Officer shall make an entry in the Service Register of the applicant incorporating all the conditions and undertaking obtained from him." }
];